import { topics } from '@/mocks/homeMangaData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">漫画爱好者正在热烈讨论的热门话题与标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {topic.name}
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
              {topic.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}